import { castResponse } from "@utils/hooks/useTypedRequest";
import { PostRequest } from "./http/BaseRequest";
import W2UiFilterBuilder from "./w2ui";
import { RecordsResponse } from "./http/responses/BaseResponse";

export interface IPoolTemplateType {
  Id: number;
  Address: string;
  Name: string;
}

export const createPoolTemplate = {
  makeRequest(address: string) {
    const builder = new W2UiFilterBuilder();
    builder.setEdit({ recid: "new", address, name: address });
    return new PostRequest("/pools/address/w2ui", builder.build().stringParams);
  },
  makeResponse: castResponse<RecordsResponse<IPoolTemplateType>>,
};

export const editPoolTemplate = {
  makeRequest(id: number, address: string) {
    const builder = new W2UiFilterBuilder();
    builder.setEdit({ recid: id, address });
    return new PostRequest("/pools/address/w2ui", builder.build().stringParams);
  },
};

export const deletePoolTemplate = {
  makeRequest(id: number) {
    const builder = new W2UiFilterBuilder();
    builder.setDelete(id);
    return new PostRequest("/pools/address/w2ui", builder.build().stringParams);
  },
};

export const getPoolTemplates = {
  makeRequest() {
    const builder = new W2UiFilterBuilder();
    return new PostRequest("/pools/address/w2ui", builder.build().stringParams);
  },
  makeResponse: castResponse<RecordsResponse<IPoolTemplateType>>,
};
